/**
 * Thousands formatter
 * @param value Value
 * @param isRawValue Value not inserted by the user
 * @example 
 * // With value inserted by the user
 * convertToThousands("1500,50"); // return 1.500,50
 * @example 
 * // With value not inserted by the user
 * convertToThousands(100.50, true); // returns 100,50
 */
export const convertToThousands = (value: string | number, isRawValue = false) => {
    let newValue = typeof value === 'number' ? String(value) : value;
    if (isRawValue) newValue = newValue.replace('.', ',');
    newValue = newValue.replace(/[^0-9,]/g, '');

    if (newValue.startsWith(',')) {
        newValue = newValue.substring(1);
    }

    const [integerPart, decimalPart] = newValue.split(',');
    let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (/^0[0-9]+$/.test(integerPart)) {
        formattedIntegerPart = /^00+$/.test(integerPart) ? '0' : integerPart.substr(1);
    }

    let formattedValue = '';
    if (decimalPart !== undefined) {
        formattedValue = `${formattedIntegerPart},${decimalPart !== '' && decimalPart.length > 3 ? decimalPart.substring(0, 3) : decimalPart}`;
    } else {
        formattedValue = formattedIntegerPart;
    }

    return formattedValue
}

export const convertNumberFromThousands = (value: any) => {    
    return Number(String(value).replace(/\./g, '').replace(',', '.'));
}
  


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/formatter.ts